import { Head, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import BillingRecoveryLayout from "@/layouts/billing_recovery_layout";

export default function BillingRequired() {
  const { t } = useTranslation();
  const resourceSelection =
    usePage().props.billing_access?.reason === "resource_selection_required";
  const title = t(
    resourceSelection ? "resources.paused" : "recovery.contact_title",
  );
  return (
    <BillingRecoveryLayout>
      <Head title={title} />
      <h1 className="text-page font-display">{title}</h1>
      <p className="text-muted-foreground mt-3">
        {t("recovery.contact_description")}
      </p>
    </BillingRecoveryLayout>
  );
}
